import { APIS } from "./api";
import React, { useEffect, useState } from "react";
import TickMarkSvg from "./assets/tick-mark.svg"
import "./styles.scss";
import referralParentLoginEvents from "./events";

let resendOTPTimer: any = null;

const getParams = () => {
  const params = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(params.entries());
  return queryParams;
}

export const ReferralParentLoginView = () => {
  const [otpSent, setOTPSent] = useState(false);
  const [otp, setOTP] = useState("");
  const [timer, setTimer] = useState(0);
  // @ts-ignore
  const [email, setEmail] = useState(window.REFFERED_PARENT_EMAIL);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [showResendSuccessMsg, setShowResendSuccessMsg] = useState(false)
  const [isTyping, setIsTyping] = useState(false);
  const [inputMethod, setInputMethod] = useState('');

  const params = getParams();

  useEffect(() => {
    let rightHeader : any = document.querySelectorAll(".right.main-nav")?.[0]
    if(rightHeader){
      rightHeader.style.display = "none"
    }
    referralParentLoginEvents.viewedLoginViaOtp({ invitationSource: params?.referral_type, referrerPage: params?.referrer_page, fromPage: params?.from_page });

    return () => {
      if(rightHeader){
        rightHeader.style.display = "block"
      }

      if (resendOTPTimer) {
        resendOTPTimer = null;
        clearInterval(resendOTPTimer);
      }
    };
  }, []);

  const setOTPTimer = (timeInSeconds: number) => {
    if (!resendOTPTimer) {
      setTimer(timeInSeconds);
      resendOTPTimer = setInterval(() => {
        setTimer((count) => {
          if (count == 1) {
            clearInterval(resendOTPTimer);
            resendOTPTimer = null;
          }
          return count - 1;
        });
      }, 1000);
    }
  }

  const sendOTP = () => {
    referralParentLoginEvents.interactedLoginViaOtp({
      clickedOn: userId ? "Resend code": "Login with OTP",
      otpEntered: false,
      invitationSource: params?.referral_type, 
      referrerPage: params?.referrer_page
    })
    if (email?.length) {
      setError(null)
      setOTPTimer(45)
      APIS[userId? "resendOTP" : "sendOTP"](email, userId).then((res: any) => {
        if(userId){
          setShowResendSuccessMsg(true)
        }
        if (res?.data?.id) {
          setUserId(res?.data?.id);
          setOTPSent(true);
        }
      });
    }
  };

  const handleLogin = () => {
    if (otpSent) {
      referralParentLoginEvents.interactedLoginViaOtp({
        clickedOn: "Login with OTP",
        otpEntered: true,
        invitationSource: params?.referral_type, 
        referrerPage: params?.referrer_page
      })
      if((otp?.length === 6) && userId){
        referralParentLoginEvents.ptlParentLoginAttemptedEvent({ invitationSource: params?.referral_type, referrerPage: params?.referrer_page});
        APIS.verifyOTP(userId, email, otp, "ptl_parent", params?.referral_type, params?.referrer_page ).then((res: any) => {
          localStorage.removeItem("referral_type");
          localStorage.removeItem("referrer_page");
          // @ts-ignore
          window.location.href = window.REDIRECTION_PATH || res?.data?.url || "/";
        }).catch((err) => {
          setError(err?.response?.data)
        })
      }
    } else {
      sendOTP();
    }
  };

  const sendEventOnPaste = () => {
    setInputMethod('pasted');
    referralParentLoginEvents.interactedLoginViaOtp({
      clickedOn: "OTP",
      otpEntered: false,
      interactionDetails: "Copy pasted",
      invitationSource: params?.referral_type, 
      referrerPage: params?.referrer_page
    })
  }

  const onChangeOTP = ({ target } :  React.ChangeEvent<HTMLInputElement>) => {
    if(!isTyping && (inputMethod !== 'pasted')){
      referralParentLoginEvents.interactedLoginViaOtp({
        clickedOn: "OTP",
        otpEntered: false,
        interactionDetails: "Started typing",
        invitationSource: params?.referral_type, 
        referrerPage: params?.referrer_page
      })
      setIsTyping(true)
    }
    setOTP(target?.value)
  }

  return (
    <div className="referral-parent-login">
      <div className={"login-box" + (otpSent ? " otp-sent": "")}>
        {!otpSent && <h4>You already have a parent account with</h4>}
        {/* @ts-ignore */}
        {!otpSent && <h4>{window.REFFERED_PARENT_EMAIL}</h4>}
        <div className="form-field">
          <label>Email </label>
          <input
            value={email}
            type="email"
            placeholder="Enter Email"
            autoFocus={true}
            tabIndex={1}
            disabled={true}
            readOnly={otpSent}
            onChange={({ target }) => setEmail(target?.value)}
          />
          {otpSent && (
            <p className="info">
              We’ve sent a verification code to the email above. Please enter it
              to complete verification
            </p>
          )}
        </div>
        {otpSent && (
          <div className="form-field">
            <label>
              Enter Verification code{" "}
              <a
                className={`${timer ? "disabled otp-timer" : ""}`}
                onClick={() => sendOTP()}
              >
                Resend code
                {timer ? (
                  <>
                    {" "}
                    in <strong>{timer}s</strong>
                  </>
                ) : (
                  ""
                )}
              </a>
            </label>
            <div className="otp-text">
              <input
                type="text"
                className="otp"
                maxLength={6}
                autoComplete="off"
                onChange={onChangeOTP}
                autoFocus={true}
                value={otp}
                onPaste={sendEventOnPaste}
              />
              <input className="autocomplete" type="email" readOnly />
              {["", "", "", "", "", ""].map((char, index) => (
                <div className={"otp-box" + (otp?.[index]? " highlight": "")} key={index}>
                  {otp?.[index] || ""}
                </div>
              ))}
            </div>
          </div>
          
        )}
        {error && <h5 className="error-msg">{error?.debug_message}</h5>}
        {!error && showResendSuccessMsg && <h5 className="resend-msg">
          <TickMarkSvg/>
          A new verification code has been sent.
          </h5>}
        <button onClick={handleLogin} tabIndex={3} className={((otpSent && otp.length < 6) ? " disabled": "")}>
          Login with OTP
        </button>
        {!otpSent && <div className="tnc">
          By Signing in, you agree to our <a href="/terms-of-use">Terms of Use</a> &{" "}
          <a href="/privacy">Privacy Policy</a>
        </div>}
      </div>
    </div>
  );
};
